<template>
	<div>
		<v-form @submit.prevent="pacientes">
			<v-layout row justify-start>
				<v-flex xs12 md2>
					<v-text-field
						autofocus
						outlined
						v-model="buscar_nombre"
						label="Nombre"
					>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md2>
					<v-text-field
						outlined
						v-model="buscar_celular"
						label="Teléfono"
						type="number"
						min="0"
					>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md2>
					<v-text-field
						outlined
						v-model="buscar_email"
						label="E-Mail"
					>
					</v-text-field>
				</v-flex>
				<v-flex xs12 md4>
					<v-btn
						type="submit"
						large
						color="primary"
						@click="pacientes()"
						:disabled="!valid_search"
					>
						Buscar
					</v-btn>
				</v-flex>
				<v-flex xs12 md2 text-right>
					<v-btn large color="primary" @click="nueva">
						<v-icon>add</v-icon> Nuevo Paciente
					</v-btn>
				</v-flex>
			</v-layout>
		</v-form>
		<v-card>
			<v-card-text>
				<v-simple-table fixed-header height="660px">
					<thead>
						<tr>
							<th>
								Código
							</th>
							<th>
								Nombre
							</th>
							<th>
								Dirección
							</th>
							<th>
								Teléfono
							</th>
							<th>
								E-Mail
							</th>
							<th width="50"></th>
						</tr>
					</thead>
					<tbody v-if="!lista_pacientes.length">
						<td colspan="5">
							<div class="ma-3">
								No se encontraron pacientes
							</div>
						</td>
					</tbody>

					<tbody>
						<template v-for="paciente in lista_pacientes">
							<tr
								:key="paciente.PacienteID"
								class="link"
								@click.prevent="
									abrirPaciente(paciente.PacienteID)
								"
							>
								<td>{{ paciente.PacienteID }}</td>
								<td>
									{{ paciente.Nombres }}
									{{ paciente.PrimerApellido }}
									{{ paciente.SegundoApellido }}
								</td>
								<td>
									{{ paciente.Calle }},
									{{ paciente.Colonia }},
									{{ paciente.CodigoPostal }}
									{{ paciente.DelegacionMunicipio }},
									{{ paciente.Descripcion }}
									{{ paciente.Estado }}
								</td>
								<td>{{ paciente.Telefono }}</td>
								<td>{{ paciente.CorreoElectronico }}</td>
								<td><v-icon>chevron_right</v-icon></td>
							</tr>
						</template>
					</tbody>
				</v-simple-table>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import ServicioPacientes from "../../services/pacientes";
export default {
	name: "pacientes",
	data() {
		return {
			lista_pacientes: [],
			buscar_nombre: "",
			buscar_celular: "",
			buscar_email: ""
		};
	},
	methods: {
		abrirPaciente(pacienteId) {
			this.$router.push(`/nutricion/perfil-paciente/${pacienteId}`);
		},
		async pacientes() {
			let res = await ServicioPacientes.get_pacientes(
				this.buscar_nombre,
				"",
				this.buscar_celular,
				this.buscar_email
			);
			this.lista_pacientes = res.data.data.Table0.map(a => ({ ...a }));
		},
		nueva() {
			this.$router.push("/nutricion/nuevo-paciente");
		}
	},
	computed: {
		valid_search() {
			return (
				this.buscar_nombre.length > 2 ||
				this.buscar_celular.length > 2 ||
				this.buscar_email.length > 2
			);
		}
	}
};
</script>

<style></style>
